import DateRangePickerInput from "./DateRangePickerInput"
import { useDateRangePickerContext } from "./dateRangePicker.context"

function DateRangePickerInputs() {
  const {
    mode,
    start,
    end,
    minDate,
    maxDate,
    activeEdge,
    commitStart,
    commitEnd,
    setActiveEdge,
  } = useDateRangePickerContext()

  return (
    <div className="ui-date-picker-inputs">
      {mode === "within" && (
        <>
          <DateRangePickerInput
            label="Start"
            date={start}
            minDate={minDate}
            maxDate={maxDate}
            active={activeEdge === "start"}
            onDateChange={commitStart}
            onFocus={() => setActiveEdge("start")}
          />
          <span className="ui-date-picker-inputs-separator">→</span>
          <DateRangePickerInput
            label="End"
            date={end}
            minDate={minDate}
            maxDate={maxDate}
            active={activeEdge === "end"}
            onDateChange={commitEnd}
            onFocus={() => setActiveEdge("end")}
          />
        </>
      )}
      {mode === "before" && (
        <DateRangePickerInput
          label="Before"
          date={end}
          minDate={minDate}
          maxDate={maxDate}
          onDateChange={commitEnd}
        />
      )}
      {mode === "after" && (
        <DateRangePickerInput
          label="After"
          date={start}
          minDate={minDate}
          maxDate={maxDate}
          onDateChange={commitStart}
        />
      )}
    </div>
  )
}

export default DateRangePickerInputs
